import { render, staticRenderFns } from "./Graphs.vue?vue&type=template&id=2fced2b1&scoped=true"
import script from "./Graphs.vue?vue&type=script&lang=js"
export * from "./Graphs.vue?vue&type=script&lang=js"
import style0 from "./Graphs.vue?vue&type=style&index=0&id=2fced2b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fced2b1",
  null
  
)

export default component.exports